export class StarBreathingGuide extends Phaser.GameObjects.Container {
  constructor(scene, x, y, path) {
    super(scene, x, y);
    scene.add.existing(this);

    this._path = [...path];
    this.pathGuideDots = scene.add.graphics();
    this.pathGuideStar = scene.add.image(0, 0, 'star_breathing', 'star_target');

    this.add([this.pathGuideDots, this.pathGuideStar]);

    this.clear();
  }

  clear() {
    this.pathGuideDots.clear();
    this.pathGuideStar.visible = false;
  }

  renderPathGuideToStar(startIndex = 0) {
    this.clear();
    this.pathGuideDots.fillStyle(0xffffff);
    for (let i = startIndex; i < this._path.length; i++) {
      const { x, y, star } = this._path[i];
      this.pathGuideDots.fillCircle(x, y, 5);
      if (i > startIndex && star) {
        this.pathGuideStar.setPosition(x, y);
        this.pathGuideStar.visible = true;
        break;
      }
    }
  }
}
